import React from 'react';
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { patchCryptoLink, deleteCryptoLink } from 'redux/crypto-links/actions';

import CommonLinkContainer
  from 'components/common/link-elements/CommonLinkContainer';
import CryptoLinktemHeaderContent
  from 'components/dashboard/crypto-links-content/CryptoLinktemHeaderContent';
import CryptoLinktemExpandedContent
  from 'components/dashboard/crypto-links-content/CryptoLinktemExpandedContent';


import './CryptoLinksListItem.css';


function CryptoLinksListItem(props) {
  const { item, patchCryptoLink, deleteCryptoLink, device } = props;

  return (
    <div className="crypto-links-list-item__component">
      <CommonLinkContainer
        linkItem={item}
        patchLinkFunction={patchCryptoLink}
        allowExpand={(device !== 'desktop')}
        headerContent={
          <CryptoLinktemHeaderContent
            key={`location-link-item-header-content-key-${item.id}`}
            item={item}
            deleteCryptoLink={deleteCryptoLink}
          />
        }
        expandedContent={
          <CryptoLinktemExpandedContent
            key={`location-link-item-expanded-content-key-${item.id}`}
            item={item}
            deleteCryptoLink={deleteCryptoLink}
          />
        }
      />
    </div>
  );
}

CryptoLinksListItem.propTypes = {
  patchCryptoLink: PropTypes.func.isRequired,
  deleteCryptoLink: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  device: PropTypes.string.isRequired,
};

const mapStateToProps = state => (
  {
    device: state.commonReducer.device,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCryptoLink,
    deleteCryptoLink,
  },
)(CryptoLinksListItem);
